import React from "react";
//#region types
import { ChartTypeSelectorProps } from "models/propTypes/chartProps";
//#endregion
//#region components
import { Input, MenuItem, SelectChangeEvent } from "@mui/material";
import useChartContext from "./context/useContext";
import ControlledSelect from "../forms/baseFields/select";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const ChartTypeSelector: React.FC<ChartTypeSelectorProps> = (props) => {
  const chartContext = useChartContext();

  React.useEffect(() => {
    if (chartContext?.filter.chartType !== props.chartTypes?.[0]) {
      chartContext?.setChartFilter({
        ...chartContext.filter,
        chartType: props.chartTypes?.[0],
      });
    }
  }, []);

  const onChangeHandler = (event: SelectChangeEvent<string | number>) => {
    chartContext?.setChartFilter({ ...chartContext.filter, chartType: Number(event.target.value) });
  };

  return props.chartTypes && props.chartTypes.length > 1 ? (
    <ControlledSelect
      value={chartContext?.filter?.chartType ?? ""}
      onChange={onChangeHandler}
      input={<Input disableUnderline={true} />}
      classes={{ select: cssExports.itemSelector }}
      variant={"filled"}
    >
      {props.chartTypes?.map((item) => (
        <MenuItem
          className={cssExports.popoverItem}
          key={item}
          value={item}
          classes={{ selected: cssExports.selected }}
        >
          {LocalizationHelperInstance.getFormattedMessage(`${props.localization}_${item}`)}
        </MenuItem>
      ))}
    </ControlledSelect>
  ) : (
    <></>
  );
};

export default ChartTypeSelector;
